<template>
    <v-container>
        <v-card  style="border-radius: 8px;">
            <v-layout>
                <v-flex xs3 class="mt-3 ml-4">
                     <div class="title font-weight-regular mt-3"> Domains whitelisting</div>
                </v-flex>
                <v-flex xs4 class="mt-3 ml-4">
                    <v-textarea
                        label="Domain"
                        outline
                        rows="1"
                        auto-grow
                        v-model="wlisting"
                    ></v-textarea>
                    <v-btn flat round class="mt-2" color="primary" @click="saveWlisting">Add Domain</v-btn>
                </v-flex>
                <v-flex xs5>
                    <v-container>         
                    <v-list dense>
                        <template v-for="(domainvalue, index) in cdomainsList">
                            <v-list-tile
                                :key="index+'a'"
                                >
                                <v-list-tile-content>
                                    <v-list-tile-title>{{ domainvalue }}</v-list-tile-title>
                                    </v-list-tile-content>
                                <v-list-tile-action>
                                        <v-btn @click="deleteWlisting(index)" flat icon color="grey">
                                                <v-icon>delete</v-icon>
                                        </v-btn>
                                </v-list-tile-action>
                            </v-list-tile>                                   
                            <v-divider
                                v-if="index + 1 < domainsList.length"
                                :key="index"
                            ></v-divider>
                        </template>
                    </v-list>
                     </v-container>
                </v-flex>
            </v-layout>
        </v-card>       
    </v-container>
</template>

<script>

export default {
    data(){
        return{
           wlisting:null,
           domainsList: []
        }
    },
    methods:{
        saveWlisting(){
            this.domainsList.push(this.wlisting)
            let dValues = this.domainsList
            let pageid = this.$store.state.pageDetails
              FB.getLoginStatus(function(response) {
                if(response.status == 'connected') {                     
                    FB.api("/"+pageid.page_id+"/messenger_profile?access_token=" +pageid.accessToken,
                    'POST',
                    { 
                     "whitelisted_domains": dValues
                    },
                    function (response) {
                        console.log(response)           
                    });
                    
                }
                else{    
                    console.log("unable to get login status") 
                } 
                
              })
              this.wlisting = null
        },
        deleteWlisting(index){
            this.domainsList.splice(index,1)
            let dValues = this.domainsList
            let pageid = this.$store.state.pageDetails
              FB.getLoginStatus(function(response) {
                if(response.status == 'connected') {                     
                    FB.api("/"+pageid.page_id+"/messenger_profile?access_token=" +pageid.accessToken,
                    'POST',
                    { 
                     "whitelisted_domains": dValues
                    },
                    function (response) {
                        console.log(response)           
                    });
                    
                }
                else{    
                    console.log("unable to get login status") 
                } 
                
              })
        }
    },
    computed:{
        cdomainsList(){
            if (this.$store.state.pageDetails.whitelisted_domains != undefined){
                this.domainsList = this.$store.state.pageDetails.whitelisted_domains
                return this.domainsList
             }
             else{
                 let dlist = []
                 return dlist
             }
        }
    }    
}
</script>
